import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { EventMantenedorCategoriaService } from 'src/app/services/event-mantenedor-categoria.service';
import { CategoryService } from 'src/app/services/category.service';
@Component({
  selector: 'app-table-categoria',
  templateUrl: './table-categoria.component.html',
  styleUrls: ['./table-categoria.component.scss']
})
export class TableCategoriaComponent implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElementCategoria: DataTableDirective;
  dtTriggerCategoria: Subject<any> = new Subject();
  loadingCategoria = false;
  searchT: string = "";
  actualPageCategoria = 1;
  categoriaMantenedor: any;
  categoria: any;
  categoriaSelected: any;
  categoriaFilter: any;
  categoriaIdSelected: number;
  creationMode: string;
  confirmationModalTittle: string;
  confirmationModalMessage: string;
  confirmationModalHasComment = false;
  confirmationModalHasOptions = false;
  confirmationModalisCommentObligatory = false;
  confirmationModalAccept: any;
  confirmationModalOptionLabel: string;
  confirmationModalOptions: { label: string, value: any }[];
  initialArrayCategoria: any = [];
  inputMessageModal:string="";
  constructor(private categoriaService: CategoryService,
    private modalService: NgbModal,
    private eventMantenedorCategoriaService: EventMantenedorCategoriaService) { }

  ngOnInit() {
    this.refreshCategorias();

    if (this.eventMantenedorCategoriaService.subsVar == undefined) {
      this.eventMantenedorCategoriaService.subsVar = this.eventMantenedorCategoriaService.
        invokeFirstComponentFunction.subscribe((name: string) => {
          this.refreshCategorias();
        });
    }
  }
  changeSearch(e) {
    let valor = e.target.value
    console.log('Filtrando valores')
    console.log(e.target.value)
    console.log(valor.length)

    if (valor.length > 0) {
      this.actualPageCategoria = 1;
      let word = valor.toLowerCase();
      this.categoriaMantenedor = this.initialArrayCategoria.filter((item) => {
        let str = item.categoryId + item.categoryDescription
        str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return str.toLowerCase().search(word) > -1
      }
      )
      console.log('Registros encontrados')
      console.log(this.categoriaMantenedor.length)
    } else {
      this.categoriaMantenedor = this.initialArrayCategoria;
    }
  }
  ngAfterViewInit(): void {
    this.dtTriggerCategoria.next();
  }

  ngOnDestroy(): void {
    this.dtTriggerCategoria.unsubscribe();
  }

  refreshCategorias() {
    Promise.all([
      this.getCategoriaMantenedor()
    ])
      .then(results => {
        this.categoriaMantenedor = results[0];
        this.categoriaFilter = results[0];
        this.initialArrayCategoria = results[0]
        this.loadingCategoria = false;
        this.rerenderCategoria();
      })
      .catch(error => {
        this.loadingCategoria = false;
        console.error(error);
      });
  }

  refreshCategoriasCreateOrUpdate(event):void {
    this.inputMessageModal = event;
    this.refreshCategorias();
  }
  getCategoriaMantenedor(): any {
    this.loadingCategoria = true;
    return new Promise((resolve, reject) => {
      this.categoriaService.getAllCategorias()
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }
  rerenderCategoria(): void {
    this.inputMessageModal = "";
    this.dtElementCategoria.dtInstance.then((dtInstanceCategoria: DataTables.Api) => {
      dtInstanceCategoria.destroy();
      this.dtTriggerCategoria.next();
    });
    
  }
  onCreateCategoria(modal: any, mode: string, categoria: any) {
    if (mode === 'Editar') {
      const request: JSON = {
        categoriaId: categoria.categoryId,
        descripcion: categoria.categoryDescription,
        estado: categoria.status
      } as unknown as JSON;
      this.categoriaSelected = request;
    } else {
      const request: JSON = {
        categoriaId: null,
        descripcion: "",
        estado: 1// Estado habilitado para la categoria que se creará
      } as unknown as JSON;
      this.categoriaSelected = request;
    }
    const modalOptions: NgbModalOptions = { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' };
    this.creationMode = mode;
    this.modalService.open(modal, modalOptions);
  }
  openDeleteModalCategoria(modal: any, categoria: any): void {
    this.categoria = categoria;
    this.confirmationModalHasComment = false;
    this.confirmationModalHasOptions = false;
    this.confirmationModalisCommentObligatory = false;
    this.categoriaIdSelected = categoria.categoryId;
    this.confirmationModalTittle = 'Eliminar Categoria';
    this.confirmationModalMessage = `¿Seguro que desea eliminar la categoria "${categoria.categoryDescription}"?`;
    this.confirmationModalAccept = this.onDeleteCategoria;
    this.openModal(modal);
  }
  openModal(modal: any, options: any = {}): void {
    const modalOptions = { ariaLabelledBy: 'modal-basic-title', centered: true, ...options };
    this.modalService.open(modal, modalOptions);
  }
  onDeleteCategoria(): void {
    // const categoria = this.categoria;
    // const request: JSON = {
    //   categoria:
    //   {
    //     categoriaId: categoria.categoryId,
    //     descripcion: categoria.categoryDescription,
    //     estado: 0
    //   }
    // } as unknown as JSON;
    this.categoriaService.deleteCategoria(this.categoria.categoryId)
      .then(response => {
        this.refreshCategorias();
      })
      .catch(error => console.error(error));
  }
  getEstadoLabel(estado: boolean): string {
    if (estado) {
      return 'Habilitado';
    } else {
      return 'Deshabilitado';
    }
  }
}
